import 'css-chunksrc/feature/modifier/ModifierBreadCrumbs.module.scss';export default {
  "root": "ModifierBreadCrumbs_root",
  "scrollContent": "ModifierBreadCrumbs_scrollContent",
  "divider": "ModifierBreadCrumbs_divider"
};